var beneficiaryDesignationCode = {
    Primary: "P",
    Contingent: "C"
};

export default beneficiaryDesignationCode;
